import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const GrantAccessIconv1 = (props: SvgProps) => (
  <Svg
    width={106}
    height={43}
    fill="none"
    {...props}
  >
    <Path
      stroke="#BF643D"
      strokeWidth={1.5}
      d="M.5 41.5C27.525 35.818 67.259 22.801 105 1.464"
    />
  </Svg>
)
export default GrantAccessIconv1
